export class Campaign {
   public userID: number;
  
   public campaignName : string;
   public campaignType : string;
   public interest : number;

   public interestName : string;
   public countrycode : string;
   public country : number;
   public newcountry:number;
   public state : number;
   public cname:string;
   public statename : string='';
   public campaignKeywords : string;
   public campaignCardDescription : string;
   public descriptionLength : number;
   public campaignImage : string;
   public campaignUrl : string;
   public campaignTitle : string;
   public headingFlag : boolean;
   public latitude : number;
   public longitude : number;
   public businessAddress : string;
   public address : string;
   public newAddress : string;
   public campaignRadius : number;
   public ageGroup : any;
   public ageGroupName : any[];
   public ageGroupAr : any=[];
   public gender : any=[];
   public campaignDays : number;
   public campaignStartTimeSlot : number;
   public campaignEndTimeSlot : number;
   public campaignStartDate : any;
   public campaignDate : any;
   public discountCpupan : string;
   public genderName : string;
   public additionalData : any;
  
  //Card detail
   public cardNumber : string;
   public expiryMonth : string;
   public expiryYear : string;
   public cvc : string;   
   public cardexpireDate : number;
   public nameOncard : string;
   public billingAddress : string;
   public newshipAddress : string;
   public totalprice : any;
   public profileImage : string;
   public loaderFlag : boolean;
   public nocId:boolean;
   public radiusSummary:any;
   public daysSummary:any;
   public hourSummary:any;
   public priceLoader : boolean;
   public matchValue:string;
   public choosAddress:string;
   public imageloaderFlag:boolean;
   public newOldAddress:string;
   public newStateid:number;
   public newCountryId:number;
   public textType:string;
   public oldLat:number;
   public oldLng:number;
   public expiretime:string;
   public custId: string;
   public cardId : string;
   public brand: string;
   public last4digit : string;
   public findDeal:boolean;
   public draftButton:boolean;
   //Coupan
   public coupanError:string;
   public coupanSuccess:string;
   public couponValid:boolean;
   public discountedAmount : number;
   public errorMsg:string;
   public errorMsgPhrase:string;
   public startAt : any;
  constructor() {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/models/compaign.ts